import {
  CreateGroupRequest,
  Group,
  GroupGuest,
} from './groupModel';
import {post, get} from "../core";
import {ErrorResponse} from "../models/error-response";


export const groupApi = () => {

  const URL_GROUP = '/v1/group'

  const create = (
    request: CreateGroupRequest
  ): Promise<Group & ErrorResponse> => {
    const formData = new FormData();
    if (request.groupImage) {
      formData.append('groupImage', request.groupImage);
    }
    formData.append('name', request.name.trim());
    formData.append('splitPreference', request.splitPreference);
    formData.append('users', JSON.stringify(request.users));
    return post(`${URL_GROUP}/create`, formData, {
      // Axios 0.21's XHR adapter removes this header for FormData; the browser supplies the boundary.
      headers: {'Content-Type': undefined},
    });
  };

  const getAll = (): Promise<Group[] & ErrorResponse> => {
    return get(`${URL_GROUP}s`);
  };

  const getGroupDetails = (request: { name?: string | string[] }): Promise<Group & ErrorResponse> => {
    return get(`${URL_GROUP}/details`, request);
  };

  const addGuest = (request: {groupName: string; name: string}): Promise<GroupGuest> => {
    return post(`${URL_GROUP}/guests`, request);
  };

  return {
    create,
    getAll,
    getGroupDetails,
    addGuest,
  };
};
